import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/navigation';

SwiperCore.use({ Pagination, Navigation });

/**
 * SAT 공통 슬라이더 컴포넌트
 * @param {ReactComponentElement} pages Slide 화면에 노출 될 페이지들
 * @param {object} options Slide 화면에 노출 될 페이지들
 * @param {string} className HTML 클래스 이름
 * @param {ReactComponentElement} customNavigation 커스텀 페이지 이동 버튼 Element
 * @param {boolean} isBullet Page Bullet 버튼 노출 여부
 * @param {boolean} isNavigation 페이지 이동 버튼 노출 여부
 * @param {boolean} isNotification Notification Element 노출 여부
 * @returns {ReactComponentElement} Slider 컴포넌트
 */
const SatSlider = ({
  pages = [],
  options = {},
  className,
  customNavigation,
  isBullet,
  isNavigation,
  isNotification,
}) => {
  return (
    <Swiper
      watchOverflow
      className={className}
      modules={[Pagination, Navigation]}
      slidesPerView="auto"
      navigation={{
        nextEl: '.swiper-box-button-next',
        prevEl: '.swiper-box-button-prev',
      }}
      pagination={{
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      }}
      {...options}
    >
      {pages.map((page, index) => (
        <SwiperSlide key={index}>{() => page}</SwiperSlide>
      ))}

      {isBullet && (
        <div className="swiper-pagination swiper-pagination-bullets">
          <span className="swiper-pagination-bullet swiper-pagination-bullet-active" />
          <span className="swiper-pagination-bullet" />
        </div>
      )}

      {customNavigation
        ? customNavigation
        : isNavigation && (
            <>
              <div className="ico swiper-box-button-next" />
              <div className="ico swiper-box-button-prev" />
            </>
          )}

      {isNotification && <span className="swiper-notification" />}
    </Swiper>
  );
};

SatSlider.propTypes = {
  pages: $propTypes.arrayOf(
    $propTypes.oneOfType([$propTypes.string, $propTypes.element]),
  ),
  options: $propTypes.object,
  className: $propTypes.string,
  customNavigation: $propTypes.element,
  isBullet: $propTypes.bool,
  isNavigation: $propTypes.bool,
  isNotification: $propTypes.bool,
};

export default SatSlider;
